export var BlockQuotation = 'blockquote';
//# sourceMappingURL=index.js.map